<template>
    <div>
        <div class="row justify-content-center">
        <div class="col-md-7" 
            :style="`background-image:url('${$store.state.data.undangan.gambar4}')`"
          style="background:#100001;position:relative;
          background-size:cover;background-repeat:no-repeat;background-position: center center;">
            <!-- <img src="@/static/draw1.jpeg" style="height:130vh;width:100%;position:absolute;right:0;top:0;z-index:10;" alt=""> -->
            <div  v-if="particle" style="height:100%;width:100%;position:absolute;z-index:10000;" id="particlesjs2" ></div>
            <br>
            <br>
             <br>
            <br>
             <br>
            <br>
            <div style="" 
              class="d-flex justify-content-center align-items-center shadow-lg rounded-lg">
                  <div style="width:100%" class=" ">
                      <div class="row justify-content-center">
                        <div class="col-10">
                             <!-- <p class=" text-center text-lg" style="font-family: 'Glory', sans-serif;letter-spacing: 3px;">
                                Assalamualaikum Wr. Wb.
                            </p> -->
                            <p class=" text-center text-2xl wow"
                            :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                             style="font-family: 'Amiri', serif;">
                                السَّلاَمُ عَلَيْكُمْ وَرَحْمَةُ اللهِ وَبَرَكَاتُهُ
                            </p>
                             <p class=" text-center text-sm wow"
                             :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                              style="font-family: 'Glory', sans-serif;letter-spacing: 3px;" v-html="$store.state.data.undangan.text_invitation">
                            </p>
                        </div>
                      </div>
                      <div class="row justify-content-center mt-2 p-3">
                        <div class="col-sm-6 mt-3 wow"
                        :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`"
                        >
                            <div class="shadow rounded-2xl p-3 bg-white text-black">
                                 <img :src="$store.state.data.undangan.gambar_pria" style="height:25vh;width:25vh;display:block;margin:auto;"
                                   class="rounded-circle shadow img-thumbnail" alt="">
                                   <p class="text-center  text-2xl font-semibold" style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">{{$store.state.data.undangan.nama_lengkap1}}</p>
                                   <p class="text-center text-sm" style="font-family: 'Glory', sans-serif;letter-spacing: 3px;" v-html="$store.state.data.undangan.keluarga1">
                                   </p>
                            </div>
                        </div>
                         <div class="col-sm-6 mt-3 wow"
                         :class="`${$store.state.data.undangan.animation=='random'?$store.state.animrandom[Math.floor(Math.random()*$store.state.animrandom.length)]:$store.state.data.undangan.animation}`">
                            <div class="shadow rounded-2xl p-3 bg-white text-black">
                                 <img :src="$store.state.data.undangan.gambar_wanita" style="height:25vh;width:25vh;display:block;margin:auto;"
                                   class="rounded-circle shadow img-thumbnail" alt="">
                                   <p class="text-center  text-2xl font-semibold" style="letter-spacing: 4px;word-spacing: 4px;font-family: 'Alex Brush', cursive;">{{$store.state.data.undangan.nama_lengkap2}}</p>
                                   <p class="text-center text-sm" style="font-family: 'Glory', sans-serif;letter-spacing: 3px;" v-html="$store.state.data.undangan.keluarga2">
                                   </p>
                            </div>
                        </div>
                      </div>
                  </div>
              </div>
            <br>
            <br>
              <br>
             <br>
            <br>
          </div>
        </div>
    </div>
</template>
<script>
import 'particles.js'
export default{
  props:['particle'],
  mounted() {
      window.particlesJS("particlesjs2", this.$store.state.particle)
  },
}
</script>